import React from 'react';
import {IReactComponent, observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';

import {resolveLogoUrl} from '../../../utils/logo-url.utils';

import './style.scss';

interface IMainTopBarProps {
    accountLogo: string;
    topBarComponent: IReactComponent;
}

@observer
export class MainTopBar extends TechseeBaseComponent<IMainTopBarProps> {
    renderInternal() {
        const TopBarComponent = this.props.topBarComponent;
        const logoUrl = resolveLogoUrl(this.props.accountLogo);

        return (
            <div className='app-top-bar use-common-styles'>
                <div className='section logo' style={{backgroundImage: `url(${logoUrl})`}} />
                <TopBarComponent />
            </div>
        );
    }
}

export default MainTopBar;
